import React, { useContext } from 'react'
import {
  SortableContainer,
  SortableElement,
  SortableHandle
} from 'react-sortable-hoc'
import { t } from '@lingui/macro'

import { notification } from '../../../../components/common/notifications/Notifications'

import SurveyQuestion from './SurveyQuestion'
import './SurveyQuestions.less'
import { ManageSurveyContext } from '../ManageSurveyContext'
import { useReorderQuestionsMutation } from '../send/surveysOperations.codegen'

const SurveyQuestions = () => {
  const { survey, refetchSurvey, questions, setQuestions } =
    useContext(ManageSurveyContext)
  const [reorderQuestions] = useReorderQuestionsMutation()

  const onSortEnd = async ({ oldIndex, newIndex }) => {
    if (oldIndex === newIndex) {
      return null
    }

    // OPTIMISTIC UI
    setQuestions((questions) => {
      const res = [...questions]
      res.splice(newIndex, 0, res.splice(oldIndex, 1)[0])

      return res
    })

    const { errors } = await reorderQuestions({
      variables: {
        input: {
          from: oldIndex + 1,
          to: newIndex + 1
        },
        surveyId: survey.id
      }
    })

    if (errors) {
      notification.error(t`Question order couldn't be updated`)
    }
    refetchSurvey()
  }

  return (
    <SortableDiv
      className="SurveyQuestions"
      lockAxis="y"
      useDragHandle
      onSortEnd={onSortEnd}
      helperClass="dragging"
    >
      {questions.map((question, index) => (
        <SurveyQuestionElement
          key={question.id}
          question={question}
          index={index}
          DragHandle={DragHandle}
        />
      ))}
    </SortableDiv>
  )
}

const SortableDiv = SortableContainer((props) => <div {...props} />)
const SurveyQuestionElement = SortableElement(SurveyQuestion)
const DragHandle = SortableHandle(() => <i className="Icon icon-menu" />)

export default SurveyQuestions
